import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from 'hooks'
import { type Route, ROUTES } from 'routes'

interface UnProtectedRouteProps {
  redirectPath?: Route
}

export const UnProtectedRoute = (props: UnProtectedRouteProps) => {
  // VRG-339: `/` decides the post-auth destination, so this guard hands the decision to
  // HomePage rather than making a sixth one. It used to default to ROUTES.CERTIFICATES,
  // which silently defeated the whole epic on the ONLY path a real user takes: a cold load
  // of `/` has no token yet, so ProtectedRoute bounces to /sign-in, the dev/WorkOS session
  // then mints one, and this guard — now seeing an authenticated user sitting on /sign-in —
  // sent them to Certificates. `/` was lost and first-run Home was never reachable.
  const { redirectPath = ROUTES.HOME } = props

  const { isAuthenticated } = useAuth()

  if (isAuthenticated) {
    return <Navigate to={redirectPath} replace />
  }

  return <Outlet />
}
